import { RouteObject } from 'react-router-dom';

import AllCourseAvg from './AllCourseAvg';
import AllCourseSplit from './AllCourseSplit';
import AnalysisPortal from './AnalysisPortal';
import SingleCourse from './SingleCourse';
import FourRate from './FourRate';
import ExportRecord from '@pages/front/pages/examCenter/pages/analysis/ExportRecord';

export interface RouteObjectWithMeta extends RouteObject {
  name?: string;
  path: string;
  icon?: string;
}

export const allCourseRoute: RouteObjectWithMeta[] = [
  {
    path: 'allCourseAvg',
    element: <AllCourseAvg />,
    name: '学科均分',
    icon: 'icon-xuekejunfen'
  },
  {
    path: '/front/analysis/allCourseSplit',
    element: <AllCourseSplit />,
    name: '总分分段分析',
    icon: 'icon-zongfenfenduanfenxi'
  },
  {
    path: '/front/analysis/all/exportRecord',
    element: <ExportRecord />,
    name: '导出学生成绩',
    icon: 'icon-daochuxueshengchengji'
  }
];

export const singleCourseRoute: RouteObjectWithMeta[] = [
  {
    path: 'singleCourseSplit',
    element: <SingleCourse />,
    name: '成绩分段分析',
    icon: 'icon-zongfenfenduanfenxi'
  },
  {
    path: 'fourRate',
    element: <FourRate />,
    name: '四率统计',
    icon: 'icon-sishuaitongji'
  },
  {
    path: '/front/analysis/single/exportRecord',
    element: <ExportRecord />,
    name: '导出学生成绩',
    icon: 'icon-daochuxueshengchengji'
  }
];

const rootRouter: RouteObjectWithMeta[] = [
  {
    path: '/front/analysis',
    element: <AnalysisPortal></AnalysisPortal>,
    children: [
      ...allCourseRoute,
      ...singleCourseRoute
    ]
  }
];


export default rootRouter;
